// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"6ba59fd2","70":"e0735f91","163":"6230aca5","725":"10623750","990":"f48a4ac7"}[chunkId] + ".chunk.js";
};